<ngx-loading-bar color="#CD67BA" height="3px" ref="http"  [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>
<notifier-container></notifier-container>
